import { render, staticRenderFns } from "./TestFilterTags.vue?vue&type=template&id=f5c6889a&scoped=true&"
import script from "./TestFilterTags.vue?vue&type=script&lang=js&"
export * from "./TestFilterTags.vue?vue&type=script&lang=js&"
import style0 from "./TestFilterTags.vue?vue&type=style&index=0&id=f5c6889a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c6889a",
  null
  
)

export default component.exports